import { render } from "./WnChoices.vue?vue&type=template&id=3767d7f1"
import script from "./WnChoices.vue?vue&type=script&lang=js"
export * from "./WnChoices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__